const routes = {
  createSaleInvoice: 'sale-invoice',
  getSaleInvoices: 'sale-invoice',
  getSaleInvoiceById: 'sale-invoice/',
  getOriginalSaleInvoiceById: 'sale-invoice/original/',
  updateSaleInvoice: 'sale-invoice/',
  deleteSaleInvoice: 'sale-invoice/',
  getCustomerByPhone: 'customer/phone/',
  calculateRecyclingFee: 'state-recycling-fee/calculate',
  getLinkedInvoices: 'sale-invoice/linked/',
};

export default routes